import { handleWindowMessage } from './message';

window.addEventListener('message', handleWindowMessage);
